module.exports = __webpack_public_path__ + "static/village_bgM@2x-27050b9e9b89e9c6dcc16863998c25da.png";